import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Illustration = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${({ src }) => src});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`
